import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import moment from 'moment';

//Components
import TextField from '../../../../components/TextField/TextField';

//Api
import ramoDeAtividade_api from '../../../../api/ramoDeAtividade_api';
import gerador_api from '../../../../api/gerador_api';

//Helpers
import { showMessage } from '../../../../helpers/message';
import mascaras from '../../../../helpers/mascaras';

//Context
import { useAuth } from '../../../../context/auth';

export default function IdentificacaoGerador({ 
    gerador, setGerador, errors, onChangeGerador, integracaoCadastros, disabledCampos = false }) {
    const { session } = useAuth();
    
    //Categorias do gerador
    const [categorias, setCategorias] = useState([
        { value: "", text: "Selecione" },
        { value: "Privado", text: "Privado" },
        { value: "Público Estadual", text: "Publico Estadual" },
        { value: "Público Federal", text: "Público Federal" },
        { value: "Público Municipal", text: "Público Municipal" },
    ]);

    //Ramos de atividade do select de ramos de atividade
    const [ramosDeAtividade, setRamosDeAtividade] = useState([
        { value: "", text: "Selecione" },
    ]);

    //carrega as opções de ramos de atividade e prefeituras assim que o componente é inicializado
    useEffect(() => {
        ramoDeAtividade_api.GetList().then(response => {
            const _ramosDeAtividade = response.data.map(value => {
                return { value: value.id, text: value.descricao }
            })
            setRamosDeAtividade([...ramosDeAtividade, ..._ramosDeAtividade]);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
    }, []);
    const onBlur = () => {
        const cpfcnpj = gerador.cpfcnpj.replace(/[^\d]/g, '');
        if (cpfcnpj.length >= 11) {
            gerador_api.GetItemByCpfCnpj(cpfcnpj).then(response => {
                if (response.data) {
                    if (!session) {
                        showMessage("Aviso", "CNPJ já cadastrado no sistema", "error", null)
                        document.getElementById('cpfcnpj').value = "";
                        return
                    }
                    response.data.tbPrefeituras_id = response.data.tbPrefeituras_id.toString();
                    response.data.tbSegmentos_Id = response.data.tbSegmentos_Id.toString();
                    response.data.tbSetores_Id = response.data.tbSetores_Id ? response.data.tbSetores_Id.toString() : null;
                    //campo só vai aparecer caso for se tiver integracaoCadastros
                    response.data.dataValidade = response.data.dataValidade ? moment(response.data.dataValidade).format("YYYY-MM-DD") : null;
                    
                    const pendenteAnalise = response.data.localidades.some(x => x.status === "Pendente");
                    if (pendenteAnalise) {
                        showMessage("Aviso", "Este gerador possui uma solicitação de cadastro pendente de análise. Efetue a análise do cadastro.", "error", null);
                    }
                    setGerador(response.data);
                } else {
                    if (integracaoCadastros) {
                        showMessage("Aviso", "Cadastro não localizado no sistema. O Gerador deve procurar a Secretaria para se cadastrar.", "error", null)
                        document.getElementById('cpfcnpj').value = "";
                    } else if(disabledCampos) {
                        showMessage("Aviso", "Cadastro não localizado no sistema", "error", null)
                        document.getElementById('cpfcnpj').value = "";
                        
                    }
                }
            })
        }
    }

    return (
        <div className='m-4 p-2 rounded-3 containerStep'>
            <Row className='mb-2'>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        maxLength={"18"}
                        id="cpfcnpj"
                        disabled={(session?.acesso?.modulo === "Transportador" && !gerador.id) ? false : !gerador.editFicha}
                        onBlur={onBlur}
                        label={"* CPF / CNPJ"}
                        invalid={errors.cpfcnpj ? true : false}
                        value={gerador.cpfcnpj}
                        onChange={onChangeGerador}
                        name="cpfcnpj"
                        mask={mascaras.cpfcnpjMask}
                    />
                    {errors.cpfcnpj && <span className={"form-control-label text-danger"}>{errors.cpfcnpj.message}</span>}
                </Col>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        disabled={!gerador.editFicha || disabledCampos}
                        label={"* Fantasia"}
                        invalid={errors.fantasia ? true : false}
                        value={gerador.fantasia}
                        onChange={onChangeGerador}
                        name="fantasia"
                    />
                    {errors.fantasia && <span className={"form-control-label text-danger"}>{errors.fantasia.message}</span>}
                </Col>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        disabled={!gerador.editFicha || disabledCampos}
                        label={"* Razão Social"}
                        invalid={errors.razao ? true : false}
                        value={gerador.razao}
                        onChange={onChangeGerador}
                        name="razao"
                    />
                    {errors.razao && <span className={"form-control-label text-danger"}>{errors.razao.message}</span>}
                </Col>
            </Row>
            <Row className='mb-2'>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        disabled={!gerador.editFicha || disabledCampos}
                        label={"* Email"}
                        invalid={errors.email ? true : false}
                        value={gerador.email}
                        onChange={onChangeGerador}
                        name="email"
                    />
                    {errors.email && <span className={"form-control-label text-danger"}>{errors.email.message}</span>}
                </Col>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        disabled={!gerador.editFicha || disabledCampos}
                        label={"* Responsável"}
                        invalid={errors.contato ? true : false}
                        value={gerador.contato}
                        onChange={onChangeGerador}
                        name="contato"
                    />
                    {errors.contato && <span className={"form-control-label text-danger"}>{errors.contato.message}</span>}
                </Col>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        maxLength={"14"}
                        mask={mascaras.celularMask}
                        disabled={!gerador.editFicha || disabledCampos}
                        label={"* Fone"}
                        invalid={errors.fone ? true : false}
                        value={gerador.fone}
                        onChange={onChangeGerador}
                        name="fone"
                    />
                    {errors.fone && <span className={"form-control-label text-danger"}>{errors.fone.message}</span>}
                </Col>
            </Row>
            <Row className='mb-2'>
                <Col md={"12"} lg={integracaoCadastros ? "3" : "4"}>
                    <TextField
                        maxLength={"14"}
                        mask={mascaras.celularMask}
                        disabled={!gerador.editFicha || disabledCampos}
                        label={"Celular"}
                        invalid={errors.celular ? true : false}
                        value={gerador.celular}
                        onChange={onChangeGerador}
                        name="celular"
                    />
                    {errors.celular && <span className={"form-control-label text-danger"}>{errors.celular.message}</span>}
                </Col>
                <Col md={"12"} lg={integracaoCadastros ? "3" : "4"}>
                    <TextField
                        disabled={!gerador.editFicha || disabledCampos}
                        label={"* Categoria"}
                        type={"select"}
                        value={gerador.categoria}
                        onChange={onChangeGerador}
                        name="categoria"
                        options={categorias}
                    />
                </Col>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        disabled={!gerador.editFicha || disabledCampos}
                        label={"* Ramo de atividade"}
                        invalid={errors.tbSegmentos_Id ? true : false}
                        type={"select"}
                        value={gerador.tbSegmentos_Id}
                        onChange={onChangeGerador}
                        name="tbSegmentos_Id"
                        options={ramosDeAtividade}
                    />
                    {errors.tbSegmentos_Id && <span className={"form-control-label text-danger"}>{errors.tbSegmentos_Id.message}</span>}
                </Col>
                {integracaoCadastros &&
                    <Col md={"12"} lg={"2"}>
                        <TextField
                            disabled={!gerador.editFicha || disabledCampos}
                            label={"Data Validade"}
                            type={"date"}
                            value={gerador.dataValidade}
                            onChange={onChangeGerador}
                            name="dataValidade"
                        />
                    </Col>
                }
            </Row>
        </div>
    );
}